var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { addMonths, format, subMonths } from "date-fns";
import React, { useCallback, useLayoutEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { ChevronDownIcon } from "../../Icons/ChevronDownIcon";
import { DropdownMenuItem } from "../../Menu/Dropdown/MenuItem";
import { Popper } from "../../Popper";
import { Text } from "../../Text";
var COUNT_OF_ITEMS = 3;
export var ITEM_TEXT_FORMAT = "LLLL y";
var Z_INDEX = "1";
var DROPDOWN_ID = "month-menu";
var MonthMenuStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .bn-monthmenu-iconcontainer {\n    display: flex;\n  }\n"], ["\n  .bn-monthmenu-iconcontainer {\n    display: flex;\n  }\n"])));
var MonthMenu = function (_a) {
    var className = _a.className, date = _a.date, handleMonthChange = _a.handleMonthChange, id = _a.id, _b = _a.reverse, reverse = _b === void 0 ? false : _b, style = _a.style;
    var _c = __read(useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    var _d = __read(useState(null), 2), ref = _d[0], setRef = _d[1];
    useLayoutEffect(function () {
        var _a, _b, _c;
        if (isOpen) {
            var monthMenu = (_c = (_b = (_a = document.getElementById(DROPDOWN_ID)) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.parentElement;
            if (monthMenu) {
                monthMenu.style.zIndex = Z_INDEX;
            }
        }
    }, [isOpen]);
    var toggleMenu = useCallback(function () {
        setIsOpen(!isOpen);
    }, [isOpen, setIsOpen]);
    var handleItemClick = useCallback(function (date) {
        handleMonthChange(date);
        setIsOpen(false);
    }, [handleMonthChange, setIsOpen]);
    var operation = useMemo(function () { return (reverse ? subMonths : addMonths); }, [reverse]);
    var data = useMemo(function () {
        return Array.from(Array(COUNT_OF_ITEMS).keys()).map(function (amount) { return ({
            value: operation(date, amount),
            text: format(operation(date, amount), ITEM_TEXT_FORMAT)
        }); });
    }, [date, operation]);
    return (React.createElement(MonthMenuStyle, { className: className, id: id, style: style },
        React.createElement(Text, { className: "bn-monthmenu-iconcontainer", color: "dark", onClick: toggleMenu, ref: setRef, tabIndex: 0, variant: "appName" },
            React.createElement(ChevronDownIcon, null)),
        React.createElement(Popper, { isOpen: isOpen, placement: "bottom-start", anchorEl: ref }, data.map(function (item) { return (React.createElement(DropdownMenuItem, { key: item.value.getTime(), onClick: function () { return handleItemClick(item.value); } }, item.text)); }))));
};
export default MonthMenu;
var templateObject_1;
//# sourceMappingURL=MonthMenu.js.map